import { render } from "./reportes.vue?vue&type=template&id=712703e4&scoped=true"
import script from "./reportes.vue?vue&type=script&lang=js"
export * from "./reportes.vue?vue&type=script&lang=js"

import "./reportes.vue?vue&type=style&index=0&id=712703e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\yordis.escorcia\\Downloads\\relojito\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712703e4"]])

export default __exports__